import Loadable from 'react-loadable'
import { Component } from 'react'

import Loading from 'components/modulor/loading'

LoadableComponent = Loadable
  loader: -> `import('./grid' /* webpackChunkName: "grid" */)`,
  loading: -> <Loading />

export default class LoadableGrid extends Component
  render: -> <LoadableComponent {...this.props} />
